import { Auth } from "aws-amplify";
import { MANAGE_USER_API } from "../helpers/api-path";
import httpClient from "./http.interceptor";

// user related lambda service methods
const createUserAPI = async (formData) => {
    const operation = "createUser";
    return userLambdaAPI(operation, formData)
}

const getUserListAPI = async (formData) => {
    const operation = "listUsers";
    return userLambdaAPI(operation, formData)
}

const updateUserAttributesAPI = async (formData) => {
    const operation = "updateUserAttributes";
    return userLambdaAPI(operation, formData)
}

const changePasswordAPI = async (formData) => {
    const operation = "changePassword";
    return userLambdaAPI(operation, formData)
}

const toggleUserAPI = async (formData) => {
    const operation = "updateUserStatus";
    return userLambdaAPI(operation, formData)
}

const userLambdaAPI = async (operation, formData) => {
    const requestBody = {
        operation,
        params: {
            ...formData
        }
    }

    // Access token only required when change password
    if (operation === "changePassword") {
        const user = await Auth.currentAuthenticatedUser();
        requestBody.params.AccessToken = user.signInUserSession.accessToken.jwtToken;
    }
    const URL = MANAGE_USER_API+"?environment="+process.env.REACT_APP_ENVIRONMENT;
    return await httpClient.post(URL, { ...requestBody });
}

export {
    createUserAPI,
    updateUserAttributesAPI,
    changePasswordAPI,
    getUserListAPI,
    toggleUserAPI,
}